import { useState } from 'react';
import { Truck, CaretDown, CaretUp, Warning } from '@phosphor-icons/react';
import { yen } from './shizaiApi';
import { jstDateTime } from '@/utils/jstDate';

const Row = ({ label, value, mono }) => (
  <div className="flex items-center justify-between gap-3 py-0.5">
    <span className="text-[10px] text-zinc-500">{label}</span>
    <span className={`text-[11px] font-semibold text-zinc-800 tabular-nums text-right ${mono ? 'font-mono' : ''}`}>{value}</span>
  </div>
);

/** 送料配賦済バッジ + 展開式の送料配賦詳細（トレース情報） */
export default function ShippingAllocBadge({ alloc, status, lineIndex }) {
  const [open, setOpen] = useState(false);
  if (!alloc?.active && status !== 'no_shipping_line_found') return null;
  if (!alloc?.active) {
    return (
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-semibold"
        data-testid={`ship-alloc-none-${lineIndex}`}>
        <Warning size={10} weight="fill" /> 送料行なし
      </span>
    );
  }
  const unit4 = (n) => '¥' + Number(n || 0).toLocaleString('ja-JP', { maximumFractionDigits: 4 });
  return (
    <div className="inline-block align-top">
      <button type="button" onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-violet-50 text-violet-700 border border-violet-200 text-[10px] font-semibold hover:bg-violet-100 transition-colors"
        data-testid={`ship-alloc-badge-${lineIndex}`}>
        <Truck size={10} weight="fill" /> 送料配賦済
        {alloc.version > 1 && <span className="text-violet-400">v{alloc.version}</span>}
        {open ? <CaretUp size={9} /> : <CaretDown size={9} />}
      </button>
      {open && (
        <div className="mt-1.5 rounded-md border border-violet-200 bg-violet-50/50 px-2.5 py-2 w-[280px]"
          data-testid={`ship-alloc-detail-${lineIndex}`}>
          <p className="text-[10px] font-bold text-violet-700 mb-1">送料配賦詳細</p>
          <Row label="元単価" value={unit4(alloc.original_unit_price)} />
          <Row label="元金額" value={yen(alloc.original_line_total)} />
          <Row label="配賦送料 / 個" value={unit4(alloc.allocated_shipping_unit)} />
          <Row label="配賦送料合計" value={yen(alloc.allocated_shipping_total)} />
          {alloc.shipping_per_item != null && <Row label="配賦送料 / 品目" value={yen(alloc.shipping_per_item)} />}
          {!!alloc.rounding_adjustment && <Row label="丸め調整" value={yen(alloc.rounding_adjustment)} />}
          <Row label="送料込単価" value={unit4(alloc.effective_unit_price_with_shipping)} />
          <Row label="送料込金額" value={yen(alloc.effective_line_total_with_shipping)} />
          <div className="my-1 border-t border-violet-200/60" />
          <Row label="配賦方式" value={alloc.allocation_method === 'equal_per_item' ? '品目均等按分' : '数量按分'} />
          {alloc.allocation_method === 'equal_per_item' && (
            <p className="text-[9px] text-violet-500 leading-snug mt-0.5 mb-1">
              送料は数量ではなく、同一バッチ内の品目数で均等に分配されています。
            </p>
          )}
          <Row label="バッチID" value={(alloc.allocation_batch_id || '').slice(0, 8)} mono />
          <Row label="TECHS出力番号" value={alloc.techs_purchase_output_no || '—'} mono />
          <Row label="送料行コード" value={alloc.shipping_code} mono />
          <Row label="計算日時" value={jstDateTime(alloc.calculated_at)} mono />
          <Row label="計算者" value={alloc.calculated_by || '—'} />
        </div>
      )}
    </div>
  );
}
